module.exports = __webpack_public_path__ + "static/media/jacket.cbd564ae.jpg";